import client from "../ApiService";
import HttpClient from "../http-client";
import { Employee } from "../types/Employee";
import { AdminEmployeeQuery } from "../types/AdminEmployee";

const baseUri: string = "/employee";

class _BasicApi {
  public client: HttpClient;
  public constructor(client: HttpClient) {
    this.client = client;
  }
}

class _EmployeeApi extends _BasicApi {
  // isActive 를 생략하면 활성/비활성을 가리지 않고 모두 조회한다.
  getEmployee(employeeType: string, isActive?: boolean, keyword?: string) {
    const params: {
      employeeType: string;
      isActive?: boolean;
      keyword?: string;
    } = {
      employeeType,
    };
    if (isActive !== undefined) {
      params.isActive = isActive;
    }
    if (keyword) {
      params.keyword = keyword;
    }
    return this.client.get(`${baseUri}`, { params });
  }
  createEmployee(employee: Employee) {
    return this.client.post(`${baseUri}/branch/create`, employee);
  }

  updateEmployee(employee: Employee) {
    return this.client.put(`${baseUri}/active`, employee);
  }

  updateEmployeeInfo(employee: Employee) {
    return this.client.put(`${baseUri}/branch/update`, employee);
  }

  getWorkplaceInfo(){
     return this.client.get(`${baseUri}/branch/workplace`);
  }

  // ── 관리자 직원 관리 화면 ──────────────────────────────
  // 비어 있는 필터는 보내지 않는다. 백엔드가 "없음 = 전체" 로 본다.
  getAdminEmployees(query: AdminEmployeeQuery) {
    const params: Record<string, string | number> = {
      page: query.page,
      size: query.size,
      sort: query.sort,
    };
    if (query.keyword) params.keyword = query.keyword;
    if (query.workplace) params.workplace = query.workplace;
    if (query.status) params.status = query.status;
    if (query.managed) params.managed = query.managed;
    if (query.flag) params.flag = query.flag;
    return this.client.get(`${baseUri}/admin/employees`, { params });
  }

  getAdminSummary() {
    return this.client.get(`${baseUri}/admin/summary`);
  }

  // DB 를 바꾸지 않는다. 지금 동기화하면 무엇이 바뀌는지만 본다.
  syncDryRun() {
    return this.client.get(`${baseUri}/sync/dry-run`);
  }

  // 가드에 걸리면 409. 아무것도 저장되지 않는다.
  syncRun() {
    return this.client.post(`${baseUri}/employee/sync`);
  }
  checkOffice365() {
    return this.client.get(`${baseUri}/azure/account/check`);
  }

  getmyInfo() {
    return this.client.get(`${baseUri}/my`);
  }
}

export const EmployeeApi = new _EmployeeApi(client);
